import { render } from "./Comics.vue?vue&type=template&id=1f0d7f93&scoped=true"
import script from "./Comics.vue?vue&type=script&lang=js"
export * from "./Comics.vue?vue&type=script&lang=js"

import "./Comics.vue?vue&type=style&index=0&id=1f0d7f93&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PC\\Documents\\vue.js\\marvel\\marvel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0d7f93"]])

export default __exports__